module.exports = __webpack_public_path__ + "media/images/search-11ddc973a8fe1db6f3663a0c294195a2.png";